import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import cloneDeep from "lodash/cloneDeep";

// Need to sync with "ProductsSelectors.ts" file whenever there is upgrade

// it currently doesn't appear that we need to memoize this. We may need to later after we resolve some issues with DataState not caching results as well as it could.
export function getComputedVariantProduct(
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
) {
    if (!variantProductState.value) {
        return parentProductState;
    }

    if (!parentProductState.value) {
        return parentProductState;
    }

    if (parentProductState.value.id === variantProductState.value.id) {
        return parentProductState;
    }

    const { value: variantProduct } = variantProductState;

    const computedProduct = cloneDeep(parentProductState.value);
    Object.assign(computedProduct, {
        productNumber: variantProduct.productNumber,
        customerProductNumber: variantProduct.customerProductNumber,
        smallImagePath: variantProduct.smallImagePath,
        mediumImagePath: variantProduct.mediumImagePath,
        largeImagePath: variantProduct.largeImagePath,
        imageAltText: variantProduct.imageAltText,
        id: variantProduct.id,
        quoteRequired: variantProduct.quoteRequired,
        productTitle: variantProduct.productTitle,
        images: variantProduct.images,
        trackInventory: variantProduct.trackInventory,
        minimumOrderQty: variantProduct.minimumOrderQty,
        canonicalUrl: variantProduct.canonicalUrl,
        unitOfMeasures: variantProduct.unitOfMeasures,
        isVariantParent: false,
        canAddToWishlist: variantProduct.canAddToWishlist,
        cantBuy: variantProduct.cantBuy,
        manufacturerItem: variantProduct.manufacturerItem,
        content:
        variantProduct.content && variantProduct.content.htmlContent !== ""
            ? variantProduct.content
            : parentProductState.value.content,
    documents:
        variantProduct.documents && variantProduct.documents.length > 0
            ? variantProduct.documents.concat(parentProductState.value.documents || [])
            : parentProductState.value.documents,
    specifications:
        variantProduct.specifications && variantProduct.specifications.length > 0
            ? variantProduct.specifications
            : parentProductState.value.specifications,
    attributeTypes:
        variantProduct.attributeTypes && variantProduct.attributeTypes.length > 0
            ? variantProduct.attributeTypes
            : parentProductState.value.attributeTypes,
    });

    return {
        isLoading: parentProductState.isLoading,
        id: variantProductState.id,
        value: computedProduct,
    };
}